/**
 * Lazy load animations
 **/
app.add({

    onLoad: function(){
        // $.getScript('/js/animations.js');
    },

});














// WEBPACK FOOTER //
// ./resources/assets/js/modules/load-animations.js